module.exports = __webpack_public_path__ + "static/img/icon-mypage-top.475baa4.png";